import { UnitActionTypes } from "./constants"

const GET_UNIT_DATA_INITIAL_STATE = {
    unitData: [],
    loading: false
}
const CREATE_UNIT_DATA_INITIAL_STATE = {
    createUnitData: [],
    loading: false
}
const UPLOAD_UNIT_DATA_INITIAL_STATE = {
    uploadUnitData: [],
    loading: false
}
const UPDATE_UNIT_DATA_INITIAL_STATE = {
    updateUnitData: [],
    loading: false,
};
const DELETE_UNIT_DATA_INITIAL_STATE = {
    deleteUnitData: [],
    loading: false,
};

const unitDataReducer = (state = GET_UNIT_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case UnitActionTypes.UNIT_DATA_LOADING:
            return {
                unitData: state.unitData,
                loading: true
            }
        case UnitActionTypes.UNIT_DATA_SUCCESS:
            return {
                unitData: action.payload,
                loading: false
            }
        case UnitActionTypes.UNIT_DATA_ERROR:
            return {
                unitData: action.payload,
                loading: false
            }
        default: return state
    }
}


const createUnitDataReducer = (state = CREATE_UNIT_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case UnitActionTypes.CREATE_UNIT_DATA_LOADING:
            return {
                createUnitData: state.createUnitData,
                loading: true
            }
        case UnitActionTypes.CREATE_UNIT_DATA_SUCCESS:
            return {
                createUnitData: action.payload,
                loading: false
            }
        case UnitActionTypes.CREATE_UNIT_DATA_ERROR:
            return {
                createUnitData: action.payload ,
                loading: false
            }
        case UnitActionTypes.STATE_EMPTY_FIRST:
            return { ...CREATE_UNIT_DATA_INITIAL_STATE };
        default: return state
    }
}

const uploadUnitDataReducer = (state = UPLOAD_UNIT_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case UnitActionTypes.UPLOAD_UNIT_DATA_LOADING:
            return {
                uploadUnitData: state.uploadUnitData,
                loading: true
            }
        case UnitActionTypes.UPLOAD_UNIT_DATA_SUCCESS:
            return {
                uploadUnitData: action.payload,
                loading: false
            }
        case UnitActionTypes.UPLOAD_UNIT_DATA_ERROR:
            return {
                uploadUnitData: action.payload ,
                loading: false
            }
        case UnitActionTypes.STATE_EMPTY_FIRST:
            return { ...UPLOAD_UNIT_DATA_INITIAL_STATE };
        default: return state
    }
}

const updateUnitDataReducer = (state = UPDATE_UNIT_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case UnitActionTypes.UPDATE_UNIT_DATA_LOADING:
            return {
                updateUnitData: action.payload,
                loading: true,
            };
        case UnitActionTypes.UPDATE_UNIT_DATA_SUCCESS:
            return {
                updateUnitData: action.payload,
                loading: false,
            };
        case UnitActionTypes.UPDATE_UNIT_DATA_ERROR:
            return {
                updateUnitData: action.payload ,
                loading: false,
            };
        case UnitActionTypes.STATE_EMPTY_FIRST:
            return { ...UPDATE_UNIT_DATA_INITIAL_STATE };
        default:
            return state;
    }
};
const deleteUnitDataReducer = (state = DELETE_UNIT_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case UnitActionTypes.DELETE_UNIT_DATA_LOADING:
            return {
                deleteUnitData: action.payload,
                loading: true,
            };
        case UnitActionTypes.DELETE_UNIT_DATA_SUCCESS:
            return {
                deleteUnitData: action.payload,
                loading: false,
            };
        case UnitActionTypes.DELETE_UNIT_DATA_ERROR:
            return {
                deleteUnitData: action.payload ,
                loading: false,
            };
        case UnitActionTypes.STATE_EMPTY_FIRST:
            return { ...DELETE_UNIT_DATA_INITIAL_STATE };
        default:
            return state;
    }
};



export {
    unitDataReducer, createUnitDataReducer, updateUnitDataReducer, deleteUnitDataReducer, uploadUnitDataReducer
}